var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ResultViewType2',{attrs:{"model":"pp","csv-item-type":"Pathway"}})
}
var staticRenderFns = []

export { render, staticRenderFns }